import config from './config'

let utils = {
  login (url = window.location.href) {
    let redirectUri = encodeURIComponent(url)
    window.location.href = `${config.adminCenterUrl}/#/login?redirect=${redirectUri}`
  },
  click (promise) {
    if (typeof promise !== 'function') {
      return () => {}
    }
    return (e, ...args) => {
      let btn = e.target
      btn.setAttribute('disabled', true)
      try {
        promise(...args)
          .then(callback, callback)
      } catch (e) {
        callback()
      }

      function callback () {
        btn.removeAttribute('disabled')
      }
    }
  },
  dragSort (arr) {
    return (e) => {
      let item = arr[e.oldIndex]
      arr.$remove(item)
      arr.splice(e.newIndex, 0, item)
    }
  }
}

export default utils



/** WEBPACK FOOTER **
 ** ./src/libs/utils.js
 **/